import { observable, action, makeObservable } from 'mobx';
import { InputClass, ISelectValueType, ValueType } from './types';

export class TextInput implements InputClass {
  dataType: 'string' | 'url';

  label: string;

  placeholder?: string;

  tag: string;

  @observable value: string | undefined | null;

  @observable selectorValue: ValueType<ISelectValueType> | undefined;

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputClass) {
    if (dataType !== 'string' && dataType !== 'url')
      throw Error(
        `Type mismatch. Type must be of "string" or "url", instead saw "${dataType}"`,
      );
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(''); // set initial value
  }

  @action
  onChange = (v: string | undefined | null) => {
    this.value = v;
  };

  @action
  clearValue = () => {
    this.value = '';
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
